// Thai copy for /web-uploader (polite, "คุณ", not stiff), translated from copy.en.ts. Same shape (checked by
// copy.test.ts). "ตัวอัปโหลดบนเว็บ" for the web uploader; "ภาพพรีวิว" and "ไฟล์ต้นฉบับ" (the originals).
// The uploader's own labels are in English, so they're quoted as it shows them (“Previews”, “Originals”).
// The text inside the two animations stays in English, like the screenshots (the uploader is in English);
// their captions, legends and accessible names are translated.
import type { WebUploaderCopy } from "./copy.en";
import en from "./copy.en";

const th: WebUploaderCopy = {
  seo: {
    title: "ตัวอัปโหลดบนเว็บของ Photohawk | เร็วกว่า FTP",
    description:
      "เราสร้างตัวอัปโหลดบนเว็บของ Photohawk ขึ้นใหม่ ส่งภาพได้ทีละหลายภาพพร้อมกัน รองรับการอัปโหลดมากกว่า 100,000 ภาพ และอัปโหลดต่อเองได้หากการเชื่อมต่อหลุด ใช้ได้ทุกแพ็กเกจ สำหรับทุกแพ็กเกจ ภาพพรีวิวขนาดเล็กจะขึ้นก่อน แกลเลอรีของคุณจึงออนไลน์ได้ในไม่กี่นาที ไม่ต้องรอเป็นชั่วโมง",
  },
  hero: {
    badge: "ใหม่",
    eyebrow: "ใช้ได้ทุกแพ็กเกจ",
    title: "ตัวอัปโหลดบนเว็บใหม่ของ Photohawk",
    subtitle:
      "เร็วกว่า FTP สร้างมาเพื่อการอัปโหลดมากกว่า 100,000 ภาพ และอัปโหลดต่อจากจุดที่ค้างไว้ได้",
    plans: "สำหรับทุกแพ็กเกจ ภาพพรีวิวที่ขึ้นก่อนช่วยให้งานใหญ่ออนไลน์ได้ในไม่กี่นาที ไม่ต้องรอเป็นชั่วโมง",
    ctaPrimary: "เปิดตัวอัปโหลดบนเว็บ",
    ctaSecondary: "ดูว่ามีอะไรใหม่",
    screenshotAlt:
      "ตัวอัปโหลดบนเว็บระหว่างการอัปโหลด เมื่อใช้ภาพพรีวิวขึ้นก่อน (ทุกแพ็กเกจ) แถบสถานะจะแสดงว่าแกลเลอรีออนไลน์ด้วยภาพพรีวิวแล้วและมีผู้เข้าชมอยู่กี่คน ส่วนคิวด้านขวาแสดงภาพพรีวิวที่เสร็จแล้วและไฟล์ต้นฉบับที่กำลังทยอยขึ้น โดยมีภาพที่มีคนซื้อแล้วสองภาพได้ขึ้นก่อน",
    phoneAlt: "ตัวอัปโหลดบนเว็บบนโทรศัพท์ เปิดอยู่ในโฟลเดอร์หนึ่งของแกลเลอรี และมีสถานะการอัปโหลดอยู่ด้านล่าง",
  },
  previews: {
    heading: "ภาพพรีวิวขึ้นก่อน",
    badge: "ทุกแพ็กเกจ",
    subtitle:
      "สำหรับทุกแพ็กเกจ: ออนไลน์ได้ในไม่กี่นาที ไม่ต้องรอเป็นชั่วโมง แกลเลอรี 10,000 ภาพออนไลน์และเริ่มขายได้ในประมาณ 8 นาที ด้วยความเร็วอัปโหลด 20 Mbps",
    body: "ภาพพรีวิวขนาดเล็กจะขึ้นก่อน แกลเลอรีของคุณจึงออนไลน์และเริ่มขายหรือเปิดให้ดาวน์โหลดฟรีได้เลย ขณะที่ไฟล์ต้นฉบับทยอยตามมา หากมีคนซื้อหรือดาวน์โหลดภาพก่อนที่ไฟล์ต้นฉบับจะมาถึง ไฟล์ต้นฉบับของภาพนั้นจะได้ลัดคิวขึ้นก่อน",
    steps: [
      { id: "previews", text: "ภาพพรีวิวขนาดเล็กขึ้นก่อน" },
      { id: "live", text: "แกลเลอรีของคุณออนไลน์" },
      { id: "buy", text: "มีคนซื้อภาพ" },
      { id: "jump", text: "ไฟล์ต้นฉบับของภาพนั้นได้ลัดคิว" },
      { id: "originals", text: "ไฟล์ต้นฉบับที่เหลือตามมา" },
    ],
    anim: {
      ...en.previews.anim,
      label: "ภาพเคลื่อนไหวอธิบายการส่งภาพพรีวิวก่อน",
      description:
        "ภาพพรีวิวขนาดเล็กของภาพหกภาพลอยจากคอมพิวเตอร์ของคุณเข้าสู่แกลเลอรี และแกลเลอรีเปลี่ยนเป็น “Live” มีคนแตะ “Buy” ที่ภาพหนึ่ง ไฟล์ต้นฉบับของภาพนั้นจึงย้ายไปอยู่หน้าสุดของคิวไฟล์ต้นฉบับและขึ้นก่อน ไฟล์ต้นฉบับที่เหลือตามมา",
    },
    link: "การอัปโหลดแบบภาพพรีวิวขึ้นก่อนทำงานอย่างไร",
  },
  faster: {
    heading: "ทำไมจึงเร็วกว่า FTP",
    subtitle: "ภาพชุดเดียวกัน ส่งสองวิธี",
    anim: {
      ...en.faster.anim,
      label: "ภาพเคลื่อนไหวเปรียบเทียบโปรแกรม FTP กับตัวอัปโหลดบนเว็บ",
      description:
        "มีสองแถว แถวบน โปรแกรม FTP ส่งภาพตามค่าเริ่มต้นครั้งละ 2 ไฟล์ และสูงสุดไม่เกิน 10 ไฟล์ แถวล่าง ตัวอัปโหลดบนเว็บส่งภาพหลายภาพพร้อมกันผ่านช่องทางที่กว้างขึ้นหรือแคบลงตามการเชื่อมต่อ สำหรับทุกแพ็กเกจ ภาพพรีวิวขนาดเล็กจะขึ้นก่อน แกลเลอรีจึงออนไลน์ได้เร็วกว่า การเชื่อมต่อหลุดไปครู่หนึ่ง แล้วการอัปโหลดก็ทำต่อเอง",
      legendPreviews: "ภาพพรีวิว",
      legendOriginals: "ไฟล์ต้นฉบับ",
    },
    points: [
      {
        id: "parallel",
        title: "หลายภาพพร้อมกัน",
        body: "ส่งภาพได้ทีละหลายภาพพร้อมกัน มากกว่าโปรแกรม FTP อย่าง FileZilla (ค่าเริ่มต้นส่งครั้งละ 2 ไฟล์ และสูงสุดไม่เกิน 10 ไฟล์) อยู่มาก",
      },
      {
        id: "adaptive",
        title: "ใช้การเชื่อมต่อของคุณได้เต็มที่",
        body: "ปรับตัวอยู่ตลอดระหว่างอัปโหลด เพื่อใช้การเชื่อมต่อของคุณได้เต็มที่",
      },
      {
        id: "scale",
        title: "สร้างมาเพื่องานใหญ่",
        body: "เราทดสอบในระดับใหญ่แล้ว รองรับการอัปโหลดมากกว่า 100,000 ภาพได้สบาย",
      },
      {
        id: "live",
        title: "ออนไลน์ได้ในไม่กี่นาที ไม่ต้องรอเป็นชั่วโมง (ทุกแพ็กเกจ)",
        body: "สำหรับทุกแพ็กเกจ ภาพพรีวิวขนาดเล็กจะขึ้นก่อน แกลเลอรี 10,000 ภาพจึงออนไลน์และเริ่มขายได้ในประมาณ 8 นาที ด้วยความเร็วอัปโหลด 20 Mbps ขณะที่ไฟล์ต้นฉบับทยอยตามมา",
      },
      {
        id: "resume",
        title: "อัปโหลดต่อจากจุดที่ค้างไว้",
        body: "หากการเชื่อมต่อหลุด ระบบจะอัปโหลดต่อเอง เพิ่มโฟลเดอร์เดิมอีกครั้ง ระบบจะส่งเฉพาะส่วนที่ยังขาด",
      },
    ],
  },
  /** The upload-time estimator (#estimate). {placeholders} are filled in by the page. */
  estimate: {
    heading: "การอัปโหลดของคุณจะใช้เวลานานเท่าไร",
    subtitle: "ประมาณการสำหรับแกลเลอรีของคุณ จากความเร็วอัปโหลดจริงของคุณเอง",
    heroLink: "ประมาณเวลาอัปโหลดของคุณ",
    photos: "จำนวนภาพ",
    custom: "อื่น ๆ",
    customLabel: "จำนวนภาพ (อื่น ๆ)",
    size: "ขนาดเฉลี่ยของไฟล์ต้นฉบับหนึ่งไฟล์",
    sizeUnit: "MB",
    sizeHint: "ไฟล์ JPEG จากงานอีเวนต์มักมีขนาดประมาณ {mb} MB",
    speed: "ความเร็วอัปโหลดของคุณ",
    speedUnit: "Mbps",
    test: "ทดสอบความเร็วอัปโหลดของฉัน",
    testing: "กำลังทดสอบ… {mbps} Mbps",
    testStarting: "กำลังทดสอบ…",
    testDone: "วัดได้: อัปโหลด {mbps} Mbps",
    testFailed: "ตอนนี้เราวัดความเร็วของคุณไม่ได้ กรอกเองได้เลย หรือลองใช้เว็บทดสอบความเร็วทั่วไป",
    dataNote: "ใช้ข้อมูลสูงสุดประมาณ {mb} MB และจะวัดเฉพาะเมื่อคุณแตะปุ่มเท่านั้น",
    otherTest: "หรือใช้เว็บทดสอบความเร็วทั่วไป",
    resultsHeading: "ผลการประมาณ",
    previewsLabel: "ภาพพรีวิวขึ้นก่อน",
    previewsPlans: "ทุกแพ็กเกจ",
    previewsLive: "แกลเลอรีออนไลน์ใน {time}",
    previewsAll: "ไฟล์ต้นฉบับทั้งหมดขึ้นครบใน {time}",
    originalsLabel: "ไฟล์ต้นฉบับอย่างเดียว",
    originalsLive: "แกลเลอรีออนไลน์ใน {time}",
    originalsWhen: "เมื่อไฟล์ต้นฉบับทั้งหมด {gb} GB ขึ้นครบ",
    computerNote: "ที่ความเร็วนี้ สิ่งที่กำหนดจังหวะคือความเร็วที่คอมพิวเตอร์ของคุณสร้างภาพพรีวิว",
    disclaimer: "เป็นเพียงการประมาณ เวลาจริงขึ้นอยู่กับการเชื่อมต่อ คอมพิวเตอร์ และภาพของคุณ",
    time: {
      under: "ไม่ถึงหนึ่งนาที",
      min: "ประมาณ {n} นาที",
      h: "ประมาณ {n} ชั่วโมง",
      d: "ประมาณ {n} วัน",
    },
    table: {
      caption: "ตัวอย่าง: 10,000 ภาพ",
      speed: "ความเร็วอัปโหลด",
      live: "ภาพพรีวิวขึ้นก่อน: แกลเลอรีออนไลน์ (ทุกแพ็กเกจ)",
      all: "ไฟล์ต้นฉบับทั้งหมดขึ้นครบ",
      note: "ตัวเลขประมาณ 8 นาทีวัดที่ความเร็วอัปโหลด 20 Mbps (ภาพพรีวิวขึ้นก่อน) แถวอื่นเป็นการประมาณจากโมเดลเดียวกัน โดยถือว่าไฟล์ต้นฉบับมีขนาดประมาณ {mb} MB",
    },
  },
  features: {
    heading: "สิ่งใหม่อื่น ๆ",
    subtitle: "หน้าจอจริงจากตัวอัปโหลดบนเว็บใหม่",
    items: [
      {
        id: "status",
        title: "สถานะที่อ่านเข้าใจง่าย",
        body: "ดูความคืบหน้าได้ในแวบเดียว เมื่อใช้ภาพพรีวิวขึ้นก่อน (ทุกแพ็กเกจ) จะเห็น “Previews” (ภาพพรีวิว) ตามด้วย “Originals” (ไฟล์ต้นฉบับ) แต่ละส่วนมีแถบความคืบหน้าของตัวเอง",
        alt: "สถานะการอัปโหลดเมื่อใช้ภาพพรีวิวขึ้นก่อน (ทุกแพ็กเกจ): “Live — saving originals…” แถบความคืบหน้าหนึ่งแถวสำหรับ Previews และอีกแถวสำหรับ Originals พร้อมข้อความ “2 photos people bought go first”",
      },
      {
        id: "queue",
        title: "วางคิวไว้ตรงไหนก็ได้",
        body: "ยึดคิวอัปโหลดไว้ด้านขวา ด้านซ้าย หรือด้านล่าง แล้วลากปรับขนาดตามที่ชอบ เบราว์เซอร์จะจำการตั้งค่าของคุณไว้",
        alt: "คิวอัปโหลดที่ยึดไว้ด้านล่างของตัวอัปโหลด โดยเปิดเมนูไว้เพื่อย้ายไปด้านขวา ด้านล่าง หรือด้านซ้าย",
      },
      {
        id: "visitors",
        title: "ดูว่าใครกำลังชมอยู่",
        body: "แถบสถานะแสดงจำนวนคนที่กำลังดูแกลเลอรีของคุณอยู่ตอนนี้ ใช้ได้ทุกแพ็กเกจ",
        alt: "แถบสถานะด้านบนของตัวอัปโหลด: “Live on previews” (เมื่อใช้ภาพพรีวิวขึ้นก่อน) และจำนวนผู้เข้าชม",
      },
      {
        id: "resume",
        title: "อัปโหลดต่อจากจุดที่ค้างไว้",
        body: "หากการเชื่อมต่อหลุด ระบบจะอัปโหลดต่อเอง เพิ่มโฟลเดอร์เดิมอีกครั้ง ระบบจะส่งเฉพาะส่วนที่ยังขาด",
        alt: "แบนเนอร์ในตัวอัปโหลดแจ้งว่าโฟลเดอร์หนึ่งยังอัปโหลดไม่เสร็จ พร้อมปุ่ม “Resume”",
      },
      {
        id: "phone",
        title: "ดูง่ายบนโทรศัพท์ด้วย",
        body: "บนหน้าจอเล็ก เส้นทางโฟลเดอร์จะย่อให้พอดี แตะ “…” เพื่อดูโฟลเดอร์ระหว่างทาง คุณจึงรู้เสมอว่าภาพกำลังไปที่ไหน",
        alt: "ตัวอัปโหลดบนโทรศัพท์: เส้นทางแสดงโฟลเดอร์ปัจจุบัน และ “…” จะเปิดรายการโฟลเดอร์ที่อยู่เหนือขึ้นไป",
      },
    ],
  },
  ftp: {
    date: "1 พฤศจิกายน 2026",
    heading: "สิ่งที่เปลี่ยนไปสำหรับ FTP ในวันที่ 1 พฤศจิกายน",
    body: "เซิร์ฟเวอร์ FTP ส่วนกลางที่เปิดตลอดเวลาของเราจะปิดในวันที่ 1 พฤศจิกายน 2026 หากตอนนี้คุณใช้ FTP อยู่ โปรดเปลี่ยนก่อนวันดังกล่าว",
    points: [
      {
        id: "closes",
        title: "FTP ส่วนกลางปิดในวันที่ 1 พฤศจิกายน 2026",
        body: "เซิร์ฟเวอร์ FTP ส่วนกลางที่เปิดตลอดเวลาจะปิดในวันที่ 1 พฤศจิกายน 2026",
      },
      {
        id: "standard",
        title: "ตัวอัปโหลดบนเว็บคือวิธีอัปโหลดมาตรฐาน",
        body: "ใช้ได้ทุกแพ็กเกจ และเริ่มใช้ได้ตั้งแต่วันนี้",
      },
      {
        id: "ondemand",
        title: "หากจำเป็นต้องใช้ FTP",
        body: "ทุกแพ็กเกจ ทุกคนในพื้นที่ทำงานของคุณเริ่มเซิร์ฟเวอร์ FTP ตามต้องการของตัวเองได้จากตัวอัปโหลดบนเว็บ ด้วยที่อยู่ส่วนตัวที่ไม่มีวันเปลี่ยน เซิร์ฟเวอร์จะปิดเองเมื่อไม่มีการใช้งานครบหนึ่งชั่วโมง",
      },
    ],
    helpLink: "FTP ตามต้องการทำงานอย่างไร",
  },
  more: {
    previewFirstTitle: "การอัปโหลดแบบภาพพรีวิวขึ้นก่อนทำงานอย่างไร",
    previewFirstBody: "สำหรับทุกแพ็กเกจ ทีละขั้นตอน: ภาพพรีวิว การออนไลน์ และสิ่งที่ผู้ซื้อเห็น",
  },
  cta: {
    heading: "ลองใช้ในการอัปโหลดครั้งถัดไป",
    body: "ตัวอัปโหลดบนเว็บใหม่พร้อมใช้แล้วในทุกแพ็กเกจ เพิ่มโฟลเดอร์ แล้วดูแกลเลอรีของคุณออนไลน์",
    button: "เปิดตัวอัปโหลดบนเว็บ",
  },
  pause: "หยุดภาพเคลื่อนไหวชั่วคราว",
  play: "เล่นภาพเคลื่อนไหว",
};

export default th;
